import { Col } from "reactstrap";
import { H4 } from "../../../../AbstractElements";
import { SubtractiveBorder } from "../../../../Constant";
import { SUBTRACTIVE_DATA } from "../../../../Data/UiKit/HelperClasses";

export const SubtractiveBorders = () => {
  return (
    <Col xl="4" sm="6">
      <div className="border-wrapper h-100 border">
        <H4 className="mb-3">{SubtractiveBorder}</H4>
        <div className="d-flex align-items-center mb-2 gap-2">
          <div className="helper-box bg-light border border-0"> </div>.border-0
        </div>
        {SUBTRACTIVE_DATA.map((item ,index) => (
          <div className="d-flex align-items-center mb-2 gap-2" key={index}>
            <div className={`helper-box bg-light border ${item}`}> </div>.{item}
          </div>
        ))}
      </div>
    </Col>
  );
};
